import { FC } from "react";
import { useParams } from "react-router-dom";

import { useCrudNavigate } from "@ryde/redux";
import {
  DrawerType,
  EditFormMode,
  RydeAppUnit,
  RydeUiUnit,
} from "@ryde/shared";

import { DrawerEditForm } from "../drawers";

interface IEditFormGeneric {
  entity: RydeUiUnit;
  isAddRoute?: boolean;
}

export const EditFormGeneric: FC<IEditFormGeneric> = ({
  entity,
  isAddRoute,
}) => {
  const { id } = useParams<{ id: string }>();
  const { navigateToList } = useCrudNavigate(entity as RydeAppUnit);
  const idOpen = Number(id) && !isAddRoute ? Number(id) : undefined;
  const idCopyFrom = Number(id) && isAddRoute ? Number(id) : undefined;
  return (
    <DrawerEditForm
      type={DrawerType.EditForm}
      entity={entity}
      mode={EditFormMode.CrudRoute}
      onCloseDrawer={navigateToList}
      id={idOpen}
      idCopyFrom={idCopyFrom}
    />
  );
};
